<div class="split-header">
    <h2 class="section-heading split-header-text">Brands we love</h2>
    <p class="body-0 split-header-text">Take the time to treat yourself.</p>
</div>
@if (isLoading() || !splitBanners()?.length) {
    <div class="hero-banner skeleton">
        <div class="skeleton-wraper">
            <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
        </div>
    </div>
} @else {
    <div class="split-banners">
        @for (banner of splitBanners() | slice: 0 : 2; track banner.id; let idx = $index) {
            <lib-background-overlay [imageUrl]="banner.imageUrl">
                <div class="split-banners__logo">
                    <lib-brand
                        [brandName]="banner.name"
                        [fallbackColor]="fallbackColor"
                        [fallbackFontSize]="fallbackFontSize"
                        [url]="banner.brandLogoUrl"
                    />
                </div>
                <ng-container footer>
                    <button
                        mat-stroked-button
                        class="mat-light-border shop-all-button"
                        [ariaLabel]="getButtonLabel(banner.name)"
                        (click)="goToBrandStore(banner)"
                    >
                        {{ getButtonLabel(banner.name) }}
                    </button>
                </ng-container>
            </lib-background-overlay>
        }
    </div>
}
